import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { APP_FILE_MANAGE_PROJECTS, APP_FILE_PROJECTS } from "./projects.constants";

const Projects = Loadable(
  lazy(() =>
    import("./Projects").then(({ Projects }) => ({
      default: Projects,
    }))
  )
);

const ManageProjects = Loadable(
  lazy(() =>
    import("./ManageProjects").then(({ ManageProjects }) => ({
      default: ManageProjects,
    }))
  )
);

const ImportProject = Loadable(
  lazy(() =>
    import("./ImportProject").then(({ ImportProject }) => ({
      default: ImportProject,
    }))
  )
);

const ProjectDetails = Loadable(
  lazy(() =>
    import("./ProjectDetails").then(({ ProjectDetails }) => ({
      default: ProjectDetails,
    }))
  )
);

export const ProjectRoutes = [
  {
          path: `${APP_FILE_PROJECTS}/`,
          exact: true,
          element: (
            <AuthorizedRoute moduleKeys={[]} allowFullAccess>
              <Projects />
            </AuthorizedRoute>
          ),
        },
        {
          path: `${APP_FILE_MANAGE_PROJECTS}`,
          exact: true,
          element: (
            <AuthorizedRoute moduleKeys={[]} allowFullAccess>
              <ManageProjects />
            </AuthorizedRoute>
          ),
        },
        {
          path: `${APP_FILE_PROJECTS}/:projectId`,
          exact: true,
          element: (
            <AuthorizedRoute moduleKeys={[]} allowFullAccess>
              <ManageProjects />
            </AuthorizedRoute>
          ),
        },
        {
          path: `/projects/import-project`,
          exact: true,
          element: (
            <AuthorizedRoute moduleKeys={[]} allowFullAccess>
              <ImportProject />
            </AuthorizedRoute>
          ),
        },
            {
          path: `/projects/get-project-details/document/:projectCode`,
          exact: true,
          element: (
            <AuthorizedRoute moduleKeys={[]} allowFullAccess>
              <ProjectDetails />
            </AuthorizedRoute>
          ),
        },
];
